import type { AnalyticsAttribution } from '../domain/analyticsEvent';

const normalize = (value: string | null | undefined, maxLength: number): string | undefined => {
  const normalized = value?.trim();
  return normalized ? normalized.slice(0, maxLength) : undefined;
};

const getReferrerHost = (): string | undefined => {
  try {
    if (!document.referrer) return undefined;
    return normalize(new URL(document.referrer).hostname.toLowerCase(), 253);
  } catch {
    return undefined;
  }
};

const getUtmSource = (): string | undefined => {
  try {
    const params = new URLSearchParams(window.location.search);
    return normalize(params.get('utm_source'), 100);
  } catch {
    return undefined;
  }
};

export const getAnalyticsAttribution = (): AnalyticsAttribution => ({
  referrerHost: getReferrerHost(),
  utmSource: getUtmSource(),
});
